export const EMBED_GOOGLE_CALENDAR_CONFIG = {
    name        : 'Google calendar',
    icon        : 'i5-google-cal',
    iconSvg     : 'isvg-google-cal',
    description : 'Embeded Google calendar',
    embedCode   : '',
    projectIcon : 'googleCalendar',                 // from ConstItemIcon and ProjectIconDictionary

    keyWords    : ['calendar.google.com']           // required for embedCode content search for autodetect EmbedType
}
